import Text from '@rockalingua/ui/components/Typography/Text';
import { staticCdnHost } from '@rockalingua/ui/constants/Cdn';

import useCurrentUser from '@/v2/domains/Auth/hooks/useCurrentUser.hook';

import { MessageHeaderWrapper, Avatar } from './MessageHeader.styled';

export default function MessageHeader() {
  const { user } = useCurrentUser();

  return (
    <MessageHeaderWrapper>
      <Avatar src={staticCdnHost + '/img/chispa.png'} alt="Chispa" />
      <Text variant="grey-18-semibold" color="black">
        Hi! {user?.firstName}
      </Text>
    </MessageHeaderWrapper>
  );
}
